import DOMPurify from 'dompurify';
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { html } from 'lit/html.js';
import { ThemeMixin } from '@cof/dxo-ui-theme';
import { DxoStyles } from './DxoUiTableStyles';
import { DxoStylesDark } from './DxoUiTableStylesDark';
import { TableData } from './models/tableData';

export class DxoUiTable extends ThemeMixin(LitElement) {
  static styles = [DxoStyles, DxoStylesDark];

  @property({ type: Object, attribute: 'data'}) data = {} as TableData;

  /*
   * Potomac Tracking
   */
  firstUpdated() {
    const potomacCustomEvent = new CustomEvent('caliper-custom-interaction', {
      detail: {
        action: 'dxo-web-component-view',
        elementName: '@cof/dxo-ui-table',
        elementType: 'modal',
        elementValue: JSON.stringify({
          webComponentVersion: '1.0.0',
        }),
      },
    });
    document.dispatchEvent(potomacCustomEvent);
  }

  isLongString(value: string) {
    if (/\s\n-/i.test(value)) {
      return false;
    }
    return value.length > 30;
  }

  render() {
    return html`
      <table class="grv-table">
        <thead class="grv-table__head">
            <tr class="grv-table__row">
                ${this.data?.header?.values?.map((value: string) =>
                  html`<th scope="col" class="grv-table__header">${value}</th>`
                )}
            </tr>
        </thead>
        <tbody class="grv-table__body">
            ${this.data?.rows?.map((row, i) =>
              html`<tr class="grv-table__row">
                ${row?.values?.map((value: string) =>
                  html`
                  <td class="grv-table__cell ${i === 0 ? 'first-row' : ''} ${this.isLongString(value) ? 'long-string' : ''}">
                    ${unsafeHTML(DOMPurify.sanitize(value))}
                  </td>`
                )}
              </tr>`
            )}
        </tbody>
      </table>`;
  }
}
